/* Country modal + bottom-sheet picker — Dansu */
(function() {
  'use strict';

  var STORAGE_KEY = 'dansu_country_confirmed';

  /* ── Country metadata ── */
  var META = {
    US: { name: 'United States', cur: 'USD $', flag: '\uD83C\uDDFA\uD83C\uDDF8', locale: null },
    CA: { name: 'Canada', cur: 'CAD $', flag: '\uD83C\uDDE8\uD83C\uDDE6', locale: null },
    AU: { name: 'Australia', cur: 'AUD $', flag: '\uD83C\uDDE6\uD83C\uDDFA', locale: null },
    DE: { name: 'Germany', cur: 'EUR €', flag: '\uD83C\uDDE9\uD83C\uDDEA', locale: 'de' },
    FR: { name: 'France', cur: 'EUR €', flag: '\uD83C\uDDEB\uD83C\uDDF7', locale: 'fr' },
    NL: { name: 'Netherlands', cur: 'EUR €', flag: '\uD83C\uDDF3\uD83C\uDDF1', locale: 'nl' },
    ES: { name: 'Spain', cur: 'EUR €', flag: '\uD83C\uDDEA\uD83C\uDDF8', locale: 'es' },
    IT: { name: 'Italy', cur: 'EUR €', flag: '\uD83C\uDDEE\uD83C\uDDF9', locale: 'it' },
    IE: { name: 'Ireland', cur: 'EUR €', flag: '\uD83C\uDDEE\uD83C\uDDEA', locale: null },
    JP: { name: 'Japan', cur: 'JPY ¥', flag: '\uD83C\uDDEF\uD83C\uDDF5', locale: 'ja' },
    GB: { name: 'United Kingdom', cur: 'GBP £', flag: '\uD83C\uDDEC\uD83C\uDDE7', locale: null },
    AT: { name: 'Austria', cur: 'EUR €', flag: '\uD83C\uDDE6\uD83C\uDDF9', locale: 'de' },
    CH: { name: 'Switzerland', cur: 'EUR €', flag: '\uD83C\uDDE8\uD83C\uDDED', locale: 'de' },
    BE: { name: 'Belgium', cur: 'EUR €', flag: '\uD83C\uDDE7\uD83C\uDDEA', locale: 'nl' },
    LU: { name: 'Luxembourg', cur: 'EUR €', flag: '\uD83C\uDDF1\uD83C\uDDFA', locale: 'fr' },
    MC: { name: 'Monaco', cur: 'EUR €', flag: '\uD83C\uDDF2\uD83C\uDDE8', locale: 'fr' },
    MX: { name: 'Mexico', cur: 'USD $', flag: '\uD83C\uDDF2\uD83C\uDDFD', locale: 'es' }
  };

  function getMeta(code) {
    return META[code] || { name: code, cur: '', flag: '', locale: null };
  }

  /* ════════════════════════════════════════
     1. GEO-DETECT MODAL
     ════════════════════════════════════════ */
  function initGeoModal() {
    var modal = document.getElementById('CountryModal');
    if (!modal) return;

    /* Already confirmed? */
    try { if (localStorage.getItem(STORAGE_KEY)) return; } catch (e) { return; }

    function getDetected() {
      return (typeof Shopify !== 'undefined' && Shopify.country) ? Shopify.country : null;
    }

    function run() {
      var detected = getDetected();
      if (!detected) return;

      var selectEl = document.getElementById('CountryModalSelect');
      var currentCountry = selectEl ? selectEl.value : null;

      /* Already on correct market */
      if (!currentCountry || detected === currentCountry) {
        try { localStorage.setItem(STORAGE_KEY, detected); } catch (e) {}
        return;
      }

      /* Check detected country is available */
      var available = false;
      if (selectEl) {
        for (var i = 0; i < selectEl.options.length; i++) {
          if (selectEl.options[i].value === detected) { available = true; break; }
        }
      }
      if (!available) {
        try { localStorage.setItem(STORAGE_KEY, detected); } catch (e) {}
        return;
      }

      /* Populate */
      var meta = getMeta(detected);
      var flagEl = document.getElementById('CountryModalFlag');
      var nameEl = document.getElementById('CountryModalDetected');
      var curEl = document.getElementById('CountryModalCurrency');

      if (flagEl) flagEl.textContent = meta.flag;
      if (nameEl) nameEl.textContent = meta.name;
      if (curEl) curEl.textContent = meta.cur;

      /* Show */
      modal.style.display = '';
      document.body.style.overflow = 'hidden';

      /* Accept — switch to detected market */
      var acceptBtn = document.getElementById('CountryModalAccept');
      if (acceptBtn) {
        acceptBtn.addEventListener('click', function() {
          try { localStorage.setItem(STORAGE_KEY, detected); } catch (e) {}
          selectEl.value = detected;
          var localeInput = document.getElementById('CountryModalLocale');
          if (localeInput && meta.locale) localeInput.value = meta.locale;
          var form = document.getElementById('CountryModalForm');
          if (form) form.submit();
        });
      }

      /* Stay on UK */
      var stayBtn = document.getElementById('CountryModalStay');
      if (stayBtn) {
        stayBtn.addEventListener('click', function() {
          closeGeoModal(currentCountry);
        });
      }

      /* Close triggers */
      var closers = modal.querySelectorAll('[data-country-modal-close]');
      for (var j = 0; j < closers.length; j++) {
        closers[j].addEventListener('click', function() {
          closeGeoModal(currentCountry);
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display !== 'none') {
          closeGeoModal(currentCountry);
        }
      });
    }

    function closeGeoModal(country) {
      try { localStorage.setItem(STORAGE_KEY, country || 'dismissed'); } catch (e) {}
      document.cookie = 'dansu_lang_manual=1;path=/;max-age=31536000;SameSite=Lax';
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    /* Delay for Shopify.country to populate */
    setTimeout(run, 600);
  }

  /* ════════════════════════════════════════
     2. BOTTOM-SHEET COUNTRY PICKER
     ════════════════════════════════════════ */
  function initCountrySheet() {
    var sheet = document.getElementById('CountrySheet');
    if (!sheet) return;

    var sheetPanel = sheet.querySelector('.cs__sheet');

    /* Country-to-locale mapping for auto-setting locale */
    var LOCALE_MAP = {
      IT:'it', DE:'de', FR:'fr', ES:'es', NL:'nl', JP:'ja',
      AT:'de', CH:'de', BE:'nl', LU:'fr', MC:'fr', MX:'es'
    };

    /* Open the sheet */
    function openSheet() {
      sheet.style.display = '';
      document.body.style.overflow = 'hidden';
      /* Reset animation */
      if (sheetPanel) {
        sheetPanel.style.animation = 'none';
        sheetPanel.offsetHeight; /* reflow */
        sheetPanel.style.animation = '';
      }
    }

    function closeSheet() {
      sheet.style.display = 'none';
      document.body.style.overflow = '';
    }

    /* Intercept nav bar country selector clicks */
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.disclosure__button.localization-selector, [data-country-sheet-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        /* Close any open disclosure */
        var disclosure = trigger.closest('.disclosure');
        if (disclosure) {
          var list = disclosure.querySelector('.disclosure__list-wrapper');
          if (list) list.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
        openSheet();
      }
    }, true);

    /* Close triggers */
    var closers = sheet.querySelectorAll('[data-country-sheet-close]');
    for (var j = 0; j < closers.length; j++) {
      closers[j].addEventListener('click', closeSheet);
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sheet.style.display !== 'none') closeSheet();
    });

    /* Country selection */
    var items = sheet.querySelectorAll('.cs__item');
    for (var k = 0; k < items.length; k++) {
      items[k].addEventListener('click', function() {
        var code = this.getAttribute('data-code');
        if (!code) return;

        /* Update hidden inputs */
        var codeInput = document.getElementById('CountrySheetCode');
        var localeInput = document.getElementById('CountrySheetLocale');
        if (codeInput) codeInput.value = code;
        if (localeInput && LOCALE_MAP[code]) localeInput.value = LOCALE_MAP[code];

        /* Save preference */
        try { localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
        document.cookie = 'dansu_lang_manual=1;path=/;max-age=31536000;SameSite=Lax';

        /* Submit form */
        var form = document.getElementById('CountrySheetForm');
        if (form) form.submit();
      });

      /* Keyboard support */
      items[k].addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    }
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initGeoModal();
      initCountrySheet();
    });
  } else {
    initGeoModal();
    initCountrySheet();
  }
})();
